export default __webpack_public_path__ + "static/media/n7.40bf0946.png";